import React from "react";
import { bool, elementType, node, number, string } from "prop-types";
import { Box, Button, Container, Typography, CircularProgress } from "@mui/material";
import { Link } from "react-router";
import googleAnalytics from "shared/analytics";

const ResourceWrapper = (props) => {
  const {
    children,
    descriptionPaddingX,
    paddingX,
    wrapperLimit,
    wrapperCount = 0,
    wrapperDescription = null,
    wrapperHref,
    WrapperIcon,
    wrapperTitle,
    loading,
  } = props;

  const showMoreButtons = wrapperCount > 0;

  let buttonText = (
    <Typography>
      View all {wrapperTitle} ({wrapperCount}){" "}
    </Typography>
  );

  if (wrapperCount <= wrapperLimit) {
    buttonText = <Typography>View {wrapperTitle} Page</Typography>;
  }

  return (
    <Container component="section" sx={{ marginBottom: 12, padding: 0, position: "relative" }}>
      {loading && <CircularProgress aria-label="Loading" />}
      {!loading && (
        <Box
          sx={(theme) => ({
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "#e7e7e7",
            borderRadius: 1,
            margin: "12px 12px 16px",
            padding: [0, 2, 0, 2],
            [theme.breakpoints.down("sm")]: {
              padding: [0, 1, 0, 1],
            },
          })}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transform: "translateY(-90%)",
              paddingRight: 2,
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                paddingRight: 2,
              }}
            >
              <WrapperIcon
                sx={{
                  color: "primary.main",
                  fontSize: "2.5rem",
                  transform: "translate(-50%, 0)",
                  background: "white",
                }}
              />
              <Typography
                component="h2"
                sx={{ color: "secondary.main", fontSize: "2rem", paddingRight: 2 }}
              >
                {wrapperTitle}
              </Typography>
            </Box>
            {showMoreButtons && (
              <Box
                sx={(theme) => ({
                  display: "inline-block",
                  backgroundColor: "white",
                  paddingLeft: 2,
                  [theme.breakpoints.down("xs")]: { display: "none" },
                })}
              >
                <Button
                  component={Link}
                  variant="outlined"
                  to={wrapperHref}
                  sx={(theme) => ({
                    borderColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.main,
                    textTransform: "none",
                    backgroundColor: "white",
                    "&:hover": {
                      backgroundColor: theme.palette.secondary.veryLight,
                    },
                  })}
                  onClick={() => {
                    googleAnalytics.trackCustomEvent({
                      eventCategory: "Landing Page",
                      eventAction: "Click view all (Top)",
                      eventLabel: wrapperTitle,
                    });
                  }}
                >
                  {buttonText}
                </Button>
              </Box>
            )}
          </Box>
          <Box sx={{ paddingLeft: paddingX, paddingRight: paddingX, paddingBottom: 4 }}>
            {wrapperCount === 0 && (
              <Typography>
                There are currently no {wrapperTitle.toLowerCase()} to display.
              </Typography>
            )}
            {wrapperCount > 0 && wrapperDescription && (
              <Box sx={{ px: descriptionPaddingX }}>
                <Typography sx={{ marginBottom: 4 }}>{wrapperDescription}</Typography>
              </Box>
            )}
            {wrapperCount > 0 && children}
          </Box>
          {showMoreButtons && (
            <Box
              sx={{
                paddingLeft: 3,
                transform: "translateY(100%)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={(theme) => ({
                  display: "inline-block",
                  backgroundColor: "white",
                  paddingLeft: 2,
                  paddingRight: 2,
                  [theme.breakpoints.down("xs")]: { display: "none" },
                })}
              >
                <Button
                  component={Link}
                  variant="outlined"
                  to={wrapperHref}
                  sx={(theme) => ({
                    borderColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.main,
                    textTransform: "none",
                    backgroundColor: "white",
                    "&:hover": {
                      backgroundColor: theme.palette.secondary.veryLight,
                    },
                  })}
                  onClick={() => {
                    googleAnalytics.trackCustomEvent({
                      eventCategory: "Landing Page",
                      eventAction: "Click view all (Bottom)",
                      eventLabel: wrapperTitle,
                    });
                  }}
                >
                  {buttonText}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Container>
  );
};

ResourceWrapper.defaultProps = {
  descriptionPaddingX: 0,
  paddingX: 5,
};

ResourceWrapper.propTypes = {
  children: node,
  descriptionPaddingX: number,
  paddingX: number,
  wrapperLimit: number.isRequired,
  wrapperCount: number,
  wrapperDescription: string,
  wrapperHref: string.isRequired,
  WrapperIcon: elementType.isRequired,
  wrapperTitle: string.isRequired,
  loading: bool.isRequired,
};

export default ResourceWrapper;
